import { createAction, props } from "@ngrx/store";
import { OfferSignatureRequested } from "../../models/offer-signature-requested";

export const findSignatureRequestAct = createAction('findSignatureRequestedEffect', props<{ id: number }>());
export const loadSignatureRequestByIdAct = createAction('loadSignatureRequestedByIdEffect', props<{ signatureRequested: OfferSignatureRequested }>());

export const updateSignatureRequestedAct = createAction('updateSignatureRequestedEffect', props<{ signatureRequestedUpdated: OfferSignatureRequested }>());
export const updateSuccessSignatureRequestedAct = createAction('updateSuccessSignatureRequestedEffect', props<{ signatureRequestedUpdated: OfferSignatureRequested }>());

export const setViolationsSignatureRequestedAct = createAction('setViolationsSignatureRequestedEffect', props<{ signatureRequestedForm: OfferSignatureRequested, violations: {} }>());

export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );